import { render, staticRenderFns } from "./secao-07-documentos.vue?vue&type=template&id=72d56340"
import script from "./secao-07-documentos.vue?vue&type=script&lang=js"
export * from "./secao-07-documentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports